import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { ref, computed, watch, onMounted } from 'vue'
import PanListFooter from '@remote/components/PanListFooter.vue'
import { isHeziNative, isAndroidHezi, isIOSHezi } from '@remote/utils/platform'
import hzAndroidBridge from '@remote/utils/jsbridge/hezi/android'
import hzIOSBridge from '@remote/utils/jsbridge/hezi/ios'
import { toast } from '@remote/utils/dialog'
import { usePathSelector } from '@remote/store/hezi-file/path-selector'
import { uuidv4, logInfo } from '@remote/utils/logger'
import type { IFileInfo } from './type'

interface IProps {
  visible: boolean
  selects: IFileInfo[]
  isLargeViewPort: boolean
}
interface IEmits {
  (e: 'retrieve'): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    visible: { type: Boolean },
    selects: null,
    isLargeViewPort: { type: Boolean }
  },
  emits: ["retrieve"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'retrieve'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean
  selects: IFileInfo[]
  isLargeViewPort: boolean
}

function logs (..._args) {
  console.log('[下载器]', ..._args)
}


const visible = computed(() => props.visible)
const traceRef = ref(uuidv4())



const { setSelectedPath } = usePathSelector()

onMounted(() => {
  if (!isHeziNative) return
})

watch(() => visible.value, () => {
  // 非盒子客户端则使用自身实现的下载器
  if (!isHeziNative) return
  const $native = isAndroidHezi ? hzAndroidBridge : hzIOSBridge
  if (visible.value) {
    // 调用客户端能力展示下载器
    logs('[showHeziPathSelector][call]')
    $native.callHandler('showHeziPathSelector', (err, result) => {
      logs('[showHeziPathSelector][response]:', err, result)
      if (err) {
        console.error(err)
      } else {
        logs('位置选择:', result)
        const traceId = traceRef.value
        logInfo('transport', {
          traceId,
          category: 'hezi_path_selector',
          action: 'change_download_path',
          desc: '修改下载路径',
          data: { platform: 'an', path: result.path },
        })
        setSelectedPath({
          id: '',
          path: result.path,
          diskName: '',
          free: -1,
          size: -1,
        })
        // 关闭下载目录选择器
        $native.callHandler('hideHeziPathSelector')
        // 触发下载
        emits('retrieve')
      }
    })
  } else {
    // 调用客户端能力隐藏下载器
    $native.callHandler('hideHeziPathSelector')
  }
})


return (_ctx: any,_cache: any) => {
  return (!_unref(isHeziNative))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(PanListFooter, {
          visible: _unref(visible),
          selects: __props.selects,
          "is-large-view-port": __props.isLargeViewPort,
          onRetrieve: _cache[0] || (_cache[0] = ($event: any) => (emits('retrieve')))
        }, null, 8, ["visible", "selects", "is-large-view-port"])
      ]))
    : _createCommentVNode("", true)
}
}

})